import React from 'react';
import classnames from 'classnames';
import { IntegrationFeed } from 'screens/IntegrationScreen';
import styles from './IntegrationScreen.module.scss';
import { VerticalNavigation, ErrorBoundary } from 'components';

export const IntegrationScreen = () => {
  return (
    <>
      <VerticalNavigation />
      <div className={styles.content}>
        <div className={classnames(styles.contentBin, styles.layoutMain)}>
          <div className={styles.MainColumn}>
            <div className={styles.FeedContainer}>
              <ErrorBoundary>
                <IntegrationFeed />
              </ErrorBoundary>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
